import { useState, useEffect } from "react";
import JobCategoryService from "../Shared/Services/JobCategoryService";
import { JobCategory } from "./models/JobCategory";
import { useNavigate, useParams } from "react-router-dom";
import SweetAlertService from "../../../services/SweetAlertService";
import { isFalse, isTrue } from "../Shared/Constants/AdminModuleConstants";

export const ViewJobCategory = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [jobCategory, setJobCategory] = useState<JobCategory>();

    useEffect(() => {
        getJobCategoryById(Number(id));
    }, []);

    const getJobCategoryById = (id: number) => {
        JobCategoryService.getJobCategoryById(id).then((response) => {
            setJobCategory(response.data);
        })
            .catch((error) => {
                SweetAlertService.error("Error", `Error : Something went wrong while getting job category by id ${id}`);
            });
    }

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h4>Job Category details</h4>
                </div>
                <div className="card-body">
                    <div className="form-group row">
                        <label className="col-sm-3 control-label"><b>Name</b></label>
                        <div className="col-sm-9">
                            {jobCategory?.name}
                        </div>
                    </div>
                    <br/>
                    <div className="form-group row">
                        <label className="col-sm-3 control-label"><b>ShortName</b></label>
                        <div className="col-sm-9">
                            {jobCategory?.shortName}
                        </div>
                    </div>
                    <br/>
                    <div className="form-group row">
                        <label className="col-sm-3 control-label"><b>Count To Sessions</b></label>
                        <div className="col-sm-9">
                            {jobCategory?.isCountToSession ? isTrue : isFalse}
                        </div>
                    </div>
                    <br/>
                    <div className="form-group row">
                        <label className="col-sm-3 control-label"><b>Is Default In JobPlan</b></label>
                        <div className="col-sm-9">
                            {jobCategory?.isDefaultInWorkActivity ? isTrue : isFalse}
                        </div>
                    </div>
                    <br />
                    {/*<div className="form-group row">*/}
                    {/*    <label className="col-sm-3 control-label"><b>Is In JobPlan</b></label>*/}
                    {/*    <div className="col-sm-9">*/}
                    {/*        {jobCategory?.isInJobPlan ? isTrue : isFalse}*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<br/>*/}
                    {/*<div className="form-group row">*/}
                    {/*    <label className="col-sm-3 control-label fw-bold"><b>Is Mandatory in JobPlan</b></label>*/}
                    {/*    <div className="col-sm-9">*/}
                    {/*        {jobCategory?.isMandatoryInJobPlan ? isTrue : isFalse}*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<br/>*/}
                    <div className="form-group row">
                        <div className=" col-sm-offset-3">
                            <a className="btn btn-secondary" onClick={() => navigate('/jobcategory')}>
                                Back
                            </a>
                            <button className="btn btn-primary ms-1" onClick={() => navigate(`/updatejobcategory/${id}`)}>
                                Edit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ViewJobCategory;